import { TreeView } from '@mui/x-tree-view/TreeView';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import SettingsSidebarComponent from './SettingsSidebarComponent';

export default function SettingsSidebar(props) {

    const { data, label, handleToggle } = props

    return (
        <TreeView
            aria-label="file system navigator"
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
        >
            <SettingsSidebarComponent
                data={data}
                label={label}
            />
        </TreeView>
    )
}